import { Controller } from '@hotwired/stimulus';
import { trackInteraction } from '../lib/track_interaction';

export default class extends Controller {
    static targets = ['required', 'ratioButton', 'ratioHint', 'total', 'seed', 'flour', 'water', 'summary', 'toast'];

    connect() {
        this.ratio = [1, 2, 2];
        this.toastTimer = null;
        const requested = Number.parseFloat(new URLSearchParams(window.location.search).get('required'));
        if (Number.isFinite(requested) && requested >= 0) this.requiredTarget.value = requested;
        this.calculate();
    }

    chooseRatio(event) {
        this.ratio = event.currentTarget.dataset.ratio.split(':').map(Number);
        trackInteraction('calculator_ratio_selected', { calculator: 'starter', ratio: event.currentTarget.dataset.ratio });
        this.ratioButtonTargets.forEach((button) =>
            button.classList.toggle('is-active', button === event.currentTarget)
        );
        this.ratioHintTarget.textContent = event.currentTarget.dataset.description;
        this.calculate();
    }

    calculate() {
        const required = Math.max(0, this.number(this.requiredTarget.value));
        const feeding = this.convenientFeeding(required);

        this.totalTarget.textContent = `${this.format(feeding.total)} г`;
        this.seedTarget.textContent = `${this.format(feeding.seed)} г`;
        this.flourTarget.textContent = `${this.format(feeding.flour)} г`;
        this.waterTarget.textContent = `${this.format(feeding.water)} г`;
        this.summaryTarget.textContent = `Используйте ${this.format(required)} г для рецепта, а ${this.format(feeding.reserve)} г оставьте для следующего кормления.`;
    }

    reset() {
        this.requiredTarget.value = 100;
        this.ratio = [1, 2, 2];
        this.ratioButtonTargets.forEach((button) =>
            button.classList.toggle('is-active', button.dataset.ratio === '1:2:2')
        );
        this.ratioHintTarget.textContent = this.ratioButtonTargets.find(
            (button) => button.dataset.ratio === '1:2:2'
        ).dataset.description;
        this.calculate();
    }

    async copy() {
        const text = [
            `Подготовить закваску: ${this.totalTarget.textContent}`,
            `Материнская закваска: ${this.seedTarget.textContent}`,
            `Мука: ${this.flourTarget.textContent}`,
            `Вода: ${this.waterTarget.textContent}`,
            this.summaryTarget.textContent
        ].join('\n');

        try {
            await navigator.clipboard.writeText(text);
            this.showToast('Расчёт скопирован');
            trackInteraction('calculator_result_copied', { calculator: 'starter' });
        } catch (_) {
            this.showToast('Не удалось скопировать', true);
        }
    }

    convenientFeeding(required) {
        const ratioTotal = this.ratio.reduce((sum, value) => sum + value, 0);
        const onePart = Math.max(5, Math.ceil((required + 20) / ratioTotal / 5) * 5);
        const [seed, flour, water] = this.ratio.map((value) => value * onePart);
        const total = seed + flour + water;
        return { seed, flour, water, total, reserve: total - required };
    }

    showToast(message, error = false) {
        clearTimeout(this.toastTimer);
        this.toastTarget.textContent = message;
        this.toastTarget.classList.toggle('bg-[#945b50]', error);
        this.toastTarget.classList.toggle('bg-[#4f3a2b]', !error);
        this.toastTarget.classList.remove('opacity-0', 'translate-y-3');
        this.toastTimer = setTimeout(() => this.toastTarget.classList.add('opacity-0', 'translate-y-3'), 2600);
    }

    number(value) {
        const result = Number.parseFloat(value);
        return Number.isFinite(result) ? result : 0;
    }

    format(value) {
        return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 1 }).format(value);
    }
}
